/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Button, CircularProgress, Grid, InputAdornment, IconButton, FormControl, Box, Alert } from '@mui/material';
import { useState } from 'react';
import { Formik, Form, Field } from 'formik'
import { makeStyles } from 'tss-react/mui';
import * as Yup from 'yup';
import { TextField } from 'formik-mui';
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import { createGetchkdUser } from '../../../../../../services/user/GetchkdUser';
import { getAllGetchkdUsers } from '../../../../../../store/reducers/getchkdUser/getchkdUserAction';


const GetchkdUserCreation = () => {

    const [loading, setLoading] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const { classes } = useStyles();
    const [error, setError] = useState("");
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);




    const handleSubmit = async ({ username, password, email }, { setSubmitting }) => {
        setSubmitting(true);
        setLoading(true);
        try {
            await createGetchkdUser({ username, password, email });
            setSubmitting(false);
            setLoading(false);
            handleClose();
            toast.success('User was registred successfully');
            setError("")
            await dispatch(getAllGetchkdUsers()).unwrap()

        } catch (error) {
            console.log('error', error)

            setSubmitting(false)
            setLoading(false);
            setError("something went wrong.")
        }


    }
    return (

        <>         .
            <Button variant="contained" color="primary" style={{ float: 'right' }} onClick={handleOpen}>Add user</Button>

            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box m={6}>
                    {error && <Alert variant="filled" color='error'>{error}</Alert>}

                    <Formik
                        initialValues={{
                            username: '',
                            password: '',
                            confirmPassword: '',
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().min(6).max(24).required('Username is required.'),
                            password: Yup.string().min(8).max(30).required('Password is required.'),
                            confirmPassword: Yup.string().min(8).max(30).oneOf([Yup.ref('password'), null], 'Passwords must match').required('password is required'),
                            email: Yup.string().email().required('Email is required')

                        })}
                        onSubmit={(
                            values, { setSubmitting, resetForm }
                        ) => {
                            handleSubmit(values, { setSubmitting, resetForm })
                        }
                        }
                    >
                        {({ isSubmitting, values, errors, touched, handleBlur, handleChange }) => (
                            <Form>
                                <FormControl fullWidth error={Boolean(touched.username && errors.username)}>

                                    <Field
                                        name="username"
                                        label="Username"
                                        type="text"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.username}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        component={TextField}

                                    />
                                </FormControl>
                                <FormControl fullWidth error={Boolean(touched.email && errors.email)}>

                                    <Field
                                        name="email"
                                        label="Email"
                                        type="email"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.email}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        component={TextField}

                                    />
                                </FormControl>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                            <Field
                                                name="password"
                                                label="Password"
                                                id="Password"
                                                type={showPassword ? "text" : 'password'}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                value={values.password}
                                                component={TextField}
                                                InputProps={{

                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => { setShowPassword(!showPassword) }}
                                                            >
                                                                {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                            <Field
                                                value={values.confirmPassword}
                                                component={TextField}

                                                name="confirmPassword"
                                                label="Confirm"
                                                type={showPassword ? "text" : 'password'}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                InputProps={{

                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => { setShowPassword(!showPassword) }}
                                                            >
                                                                {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>

                                </Grid>


                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            className={classes.button}
                                            type="submit"
                                        >
                                            {loading && <CircularProgress size={24} color="secondary" className={classes.buttonProgress} />}
                                            Register
                                        </Button>

                                    </Grid>
                                </Grid>
                            </Form>

                        )}
                    </Formik>

                </Box>
            </DialogContainer>
        </>
    )

}
const useStyles = makeStyles({ "name": { GetchkdUserCreation } })(theme => ({
    heroContent: {
        height: 'calc( 100vh - 150px)',
    },

    button: {
        margin: theme.spacing(1),
    },

    floatingLabelFocusStyle: {
        color: theme.palette.primary.main
    },
    ImgLoginDescp: {
        width: '400px',
        margin: 'auto',
        padding: '40px',
        display: 'block',
        color: 'white'
    },
    containerBox: {
        boxShadow: 'rgb(213 212 212 / 80%) 1px 5px 24px 0px',
        borderRadius: '10px',
        backgroundPosition: 'inherit',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: '100%'

    },
    BoxContainerLogin: {
        background: 'white',
        padding: '50px',
        borderRadius: '10px',
        boxShadow: 'rgb(38 127 161) 1px 5px 24px 0px',

    }
}))


export default GetchkdUserCreation;
